import { useState } from 'react';

/** What the legend filter offers its consumers. */
export type ILegendFilter = ReturnType<typeof useLegendFilter>;

/** The legend entries the viewer picked to narrow the calendar to. Lives above
 *  the view, with the period, so closing the calendar keeps it. */
export function useLegendFilter() {
  const [picked, setPicked] = useState<ReadonlySet<string>>(new Set());
  return {
    picked,
    toggle: (key: string) =>
      setPicked((current) => {
        const next = new Set(current);
        if (!next.delete(key)) next.add(key);
        return next;
      }),
    /** Picks or drops several entries at once (a group's members). */
    setAll: (keys: readonly string[], on: boolean) =>
      setPicked((current) => {
        const next = new Set(current);
        for (const key of keys) {
          if (on) next.add(key);
          else next.delete(key);
        }
        return next;
      }),
  };
}
